// extracted by mini-css-extract-plugin
export default {"footer":"DeleteModal_footer__Jnpaj"};